/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The processing status of this audio item.
 */
export const OutputAudioItemStatus = {
  InProgress: "in_progress",
  Completed: "completed",
  Incomplete: "incomplete",
} as const;
/**
 * The processing status of this audio item.
 */
export type OutputAudioItemStatus = ClosedEnum<typeof OutputAudioItemStatus>;

/**
 * Output audio item: Audio content synthesized from the model's text response via TTS.
 */
export type OutputAudioItem = {
  /**
   * The content type identifier for audio output.
   */
  type: "output_audio";
  /**
   * Base64-encoded audio data.
   */
  data: string;
  /**
   * The text transcript that was synthesized into audio.
   */
  transcript: string;
  /**
   * The unique identifier for this output audio item.
   */
  id: string;
  /**
   * The processing status of this audio item.
   */
  status: OutputAudioItemStatus;
};

/** @internal */
export const OutputAudioItemStatus$inboundSchema: z.ZodNativeEnum<
  typeof OutputAudioItemStatus
> = z.nativeEnum(OutputAudioItemStatus);
/** @internal */
export const OutputAudioItemStatus$outboundSchema: z.ZodNativeEnum<
  typeof OutputAudioItemStatus
> = OutputAudioItemStatus$inboundSchema;

/** @internal */
export const OutputAudioItem$inboundSchema: z.ZodType<
  OutputAudioItem,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("output_audio"),
  data: z.string(),
  transcript: z.string(),
  id: z.string(),
  status: OutputAudioItemStatus$inboundSchema,
});
/** @internal */
export type OutputAudioItem$Outbound = {
  type: "output_audio";
  data: string;
  transcript: string;
  id: string;
  status: string;
};

/** @internal */
export const OutputAudioItem$outboundSchema: z.ZodType<
  OutputAudioItem$Outbound,
  z.ZodTypeDef,
  OutputAudioItem
> = z.object({
  type: z.literal("output_audio"),
  data: z.string(),
  transcript: z.string(),
  id: z.string(),
  status: OutputAudioItemStatus$outboundSchema,
});

export function outputAudioItemToJSON(
  outputAudioItem: OutputAudioItem,
): string {
  return JSON.stringify(OutputAudioItem$outboundSchema.parse(outputAudioItem));
}
export function outputAudioItemFromJSON(
  jsonString: string,
): SafeParseResult<OutputAudioItem, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OutputAudioItem$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OutputAudioItem' from JSON`,
  );
}
